/* tslint:disable */
/* eslint-disable */
/**
 * MHB2B Contract API specs
 * MHB2B Contract API specs for middleware and frontend components.
 *
 * The version of the OpenAPI document: 1.61.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 * Enumerated type of Account verification state that indicates if the company account is verified
 * @export
 * @enum {string}
 */
export const AccountVerificationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Describes a binary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const BinaryBooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR'
};
/**
 * Describes a binary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const BinaryFilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER'
};
/**
 * Describes a binary boolean operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const BooleanOperator = {
    And: 'AND',
    Or: 'OR',
    Xor: 'XOR',
    Not: 'NOT'
};
/**
 * Enumerated type of business type for which is the company used for
 * @export
 * @enum {string}
 */
export const BusinessType = {
    Other: 'LOB_OTHER',
    Construction: 'LOB_CONSTRUCTION',
    Emergency: 'LOB_EMERGENCY',
    Logistic: 'LOB_LOGISTIC',
    Manufacturing: 'LOB_MANUFACTURING',
    PeopleMover: 'LOB_PEOPLE_MOVER',
    Rental: 'LOB_RENTAL',
    ServiceWorkshop: 'LOB_SERVICE_WORKSHOP',
    TradeEgrocery: 'LOB_TRADE_EGROCERY'
};
/**
 * Enumerated type of Account business verification state that indicates if the company account is verified by business commercial registration
 * @export
 * @enum {string}
 */
export const CommercialRegistrationState = {
    Valid: 'VALID',
    Invalid: 'INVALID',
    Undefined: 'UNDEFINED'
};
/**
 * Enumerated type of consent state.
 * @export
 * @enum {string}
 */
export const ConsentState = {
    Undefined: 'UNDEFINED',
    Accepted: 'ACCEPTED',
    Revoked: 'REVOKED'
};
/**
 * Describes a filter operator. Different operators may have different expected amounts of operands
 * @export
 * @enum {string}
 */
export const FilterOperator = {
    Gt: 'GT',
    Lt: 'LT',
    Gte: 'GTE',
    Lte: 'LTE',
    Eq: 'EQ',
    Neq: 'NEQ',
    Contains: 'CONTAINS',
    NotContains: 'NOT_CONTAINS',
    Before: 'BEFORE',
    NotBefore: 'NOT_BEFORE',
    After: 'AFTER',
    NotAfter: 'NOT_AFTER',
    IsNotNull: 'IS_NOT_NULL',
    IsNull: 'IS_NULL'
};
/**
 * Enumerated type of the supported filter types:   TEXT_SEARCH - allows to define an arbitrary (free-)text string   VALUE_LIST - allows to select one or more values from a pre-defined list of available values   DATE_RANGE - allows to specify an earliest/latest date (range) criteria   NUMERIC_RANGE - allows to specify a min/max numeric (range) criteria
 * @export
 * @enum {string}
 */
export const FilterOptionType = {
    TextSearch: 'TEXT_SEARCH',
    ValueList: 'VALUE_LIST',
    DateRange: 'DATE_RANGE',
    NumericRange: 'NUMERIC_RANGE'
};
/**
 * Enumerated type of the invitation state.
 * @export
 * @enum {string}
 */
export const InvitationState = {
    Undefined: 'UNDEFINED',
    Accepted: 'ACCEPTED',
    Declined: 'DECLINED',
    Pending: 'PENDING'
};
/**
 * Operation code for CUD actions
 * @export
 * @enum {string}
 */
export const Operation = {
    Create: 'create',
    Update: 'update',
    Delete: 'delete'
};
/**
 * Enumerated type of the state for preferred contacts. The state UNASSIGNED means that a contact is assignable but not yet persisted. The ASSIGNED contacts are already assigned to a company or vehicle.
 * @export
 * @enum {string}
 */
export const PreferredContactState = {
    Unassigned: 'UNASSIGNED',
    Assigned: 'ASSIGNED'
};
/**
 * Sort order:   * `asc` - Ascending, from A to Z or 0-9   * `desc` - Descending, from Z to A or 0-9
 * @export
 * @enum {string}
 */
export const SortOperator = {
    Asc: 'ASC',
    Desc: 'DESC'
};
/**
 * Describes a unary boolean operator. DEPRECATED - Please use BooleanOperator instead
 * @export
 * @enum {string}
 */
export const UnaryBooleanOperator = {
    Not: 'NOT'
};
/**
 * Describes an unary filter operator. DEPRECATED - Please use FilterOperator instead
 * @export
 * @enum {string}
 */
export const UnaryFilterOperator = {
    NotNull: 'IS_NOT_NULL',
    Null: 'IS_NULL'
};
/**
 * Enumerated type of a vehicle authorization
 * @export
 * @enum {string}
 */
export const VehicleAuthorizationType = {
    User: 'USER',
    Company: 'COMPANY',
    Partner: 'PARTNER'
};
/**
 * Options which define the input state of VehicleSalesDiscountScheme
 * @export
 * @enum {string}
 */
export const VehicleSalesDiscountSchemeOptionType = {
    None: 'NONE',
    NationalDiscountCode: 'NATIONAL_DISCOUNT_CODE',
    FleetSize: 'FLEET_SIZE',
    PurchaseCooperative: 'PURCHASE_COOPERATIVE'
};
/**
 * Enumerated type of a vehicle type. See mapping logic https://git.daimler.com/dh-io-mmcs/commons-be/blob/master/mmc_connector_client/src/main/java/com/daimler/mymercedes/mmc/backend/connectors/datacontext/VehicleInfoDC.java
 * @export
 * @enum {string}
 */
export const VehicleTypeType = {
    ConnectVehicle: 'CONNECT_VEHICLE',
    HybridVehicle: 'HYBRID_VEHICLE',
    AdapterVehicle: 'ADAPTER_VEHICLE',
    None: 'NONE'
};
/**
 * FinanceConsentsApi - axios parameter creator
 * @export
 */
export const FinanceConsentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Implements the FSP pattern to query for a list of provided consents in the leasing & finance context for a context user.
         * @param {FinanceConsentFBReq} financeConsentFBReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinanceConsents: (financeConsentFBReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'financeConsentFBReq' is not null or undefined
            assertParamExists('getFinanceConsents', 'financeConsentFBReq', financeConsentFBReq);
            const localVarPath = `/finance/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(financeConsentFBReq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {FinanceConsentCUDReq} financeConsentCUDReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyFinanceConsents: (financeConsentCUDReq, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'financeConsentCUDReq' is not null or undefined
            assertParamExists('modifyFinanceConsents', 'financeConsentCUDReq', financeConsentCUDReq);
            const localVarPath = `/finance/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'PATCH' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(financeConsentCUDReq, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * FinanceConsentsApi - functional programming interface
 * @export
 */
export const FinanceConsentsApiFp = function (configuration) {
    const localVarAxiosParamCreator = FinanceConsentsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Implements the FSP pattern to query for a list of provided consents in the leasing & finance context for a context user.
         * @param {FinanceConsentFBReq} financeConsentFBReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinanceConsents(financeConsentFBReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getFinanceConsents(financeConsentFBReq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {FinanceConsentCUDReq} financeConsentCUDReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyFinanceConsents(financeConsentCUDReq, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifyFinanceConsents(financeConsentCUDReq, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * FinanceConsentsApi - factory interface
 * @export
 */
export const FinanceConsentsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = FinanceConsentsApiFp(configuration);
    return {
        /**
         *
         * @summary Implements the FSP pattern to query for a list of provided consents in the leasing & finance context for a context user.
         * @param {FinanceConsentFBReq} financeConsentFBReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFinanceConsents(financeConsentFBReq, options) {
            return localVarFp.getFinanceConsents(financeConsentFBReq, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
         * @param {FinanceConsentCUDReq} financeConsentCUDReq
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyFinanceConsents(financeConsentCUDReq, options) {
            return localVarFp.modifyFinanceConsents(financeConsentCUDReq, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * FinanceConsentsApi - object-oriented interface
 * @export
 * @class FinanceConsentsApi
 * @extends {BaseAPI}
 */
export class FinanceConsentsApi extends BaseAPI {
    /**
     *
     * @summary Implements the FSP pattern to query for a list of provided consents in the leasing & finance context for a context user.
     * @param {FinanceConsentFBReq} financeConsentFBReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceConsentsApi
     */
    getFinanceConsents(financeConsentFBReq, options) {
        return FinanceConsentsApiFp(this.configuration).getFinanceConsents(financeConsentFBReq, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary we use PATCH instead of POST/PUT/DELETE in order to - cover the create workflow of an entity - cover the update workflow of an entity (by default with partial updates) - cover the delete workflow of an entity
     * @param {FinanceConsentCUDReq} financeConsentCUDReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FinanceConsentsApi
     */
    modifyFinanceConsents(financeConsentCUDReq, options) {
        return FinanceConsentsApiFp(this.configuration).modifyFinanceConsents(financeConsentCUDReq, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=api.js.map